<template>
    <v-card flat >
        <v-layout row wrap>
            <v-flex xs3>
                <v-layout row>
                    <v-flex>
                        <v-card class="pa-1 tickets">
                            <v-list three-line >
                                <template >
                                    <v-subheader
                                    class="title"
                                    >
                                        Tickets Abertos
                                    </v-subheader>
                                    <v-list-tile
                                    v-for="(item, index) in getTickets"
                                    :key="item.description"
                                    avatar
                                    >
                                    <v-list-tile-avatar :color="item.status == 'solved' ? 'grey' : item.status == 'pending' ? 'blue' : 'red'">
                                        <span class="white--text headline" v-html="item.status == 'solved' ? 'R' : item.status == 'pending' ? 'P' : 'A'"></span>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                            <v-list-tile-title v-html="item.description"></v-list-tile-title>
                                            <v-list-tile-sub-title v-html="item.tags[0]"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    </v-list-tile>
                                    <!--<v-divider
                                    v-if="getTickets.length > 1"
                                    :inset="true"
                                    ></v-divider>-->
                                </template>
                            </v-list>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex class="mt-3">
              <div v-if="!chamado" class="pl-5 pr-5">
                <div class="pa-5">
                    <h1 class="text-xs-center" >Abrir novo chamado</h1>
                    <v-text-field box label="Assunto" class="pt-3" v-model="novoChamado.assunto" width="300px"></v-text-field>
                    <v-textarea
                    class="pt-1 "
                    box
                    height="275"
                    label="Mensagem"
                    v-model="novoChamado.mensagem"
                    ></v-textarea>
                    <v-btn
                    class="mt-1 ml-0 "
                    round
                    dark
                    color="teal"
                    @click="envia"
                    >Enviar</v-btn>
                </div>
              </div>
              <!--<div v-else>
                <v-btn
                  flat
                  color="grey"
                  @click="chamado=false"
                >
                  <v-icon left>keyboard_arrow_left</v-icon>
                  Voltar
                </v-btn>
                <div>
                  <h1 class="text-xs-center" v-html="ticket.subject"></h1>
                  <h3 class="text-xs-center" v-html="ticket.description"></h3>
                </div>
              </div>-->


            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  export default {
    data () {
      return {
        chamado: false,
        novoChamado: {
          assunto: '',
          mensagem: '',
          tags: ''
        },
        ticket: {},
        selected: ['Astandes', 'Normalizador'],
      }
    },
    computed: {
      ...mapGetters(['getTickets'])
    },
    methods:{
      ...mapActions(['abreTicket', 'findTickets']),
      async envia(){
        this.novoChamado.tags = ['Astandes']
        let result = await this.abreTicket(this.novoChamado)
        if(result) {
            this.$eventHub.$emit('snackBar', {color: 'success', message: 'Ticket criado com sucesso, favor aguardar e-mail do Suporte.' })
            //this.findTickets()
        }
        else this.$eventHub.$emit('snackBar', {color: 'error', message: 'Erro na abertura do ticket' })
      }
    },
    mounted(){
        this.findTickets()
    }
  }
</script>

<style scoped>
.tickets {
    height: calc(100vh - 64px) !important;
}

</style>




// WEBPACK FOOTER //
// src/components/user/modais/Zendesk.vue